import PropTypes from 'prop-types';
import React from 'react';
import {Link} from 'react-router-dom';
import {Layout, Type} from '@republic/bits';
import {get} from '@republic/foundation/lang/object';
import {createComponent, use} from '@republic/react-foundation';
import $ from '@republic/spellcaster';
import AuthStream from '../../auth/streams/AuthStream';
import Copy from '../../copy/components/Copy';
import colors from '../../core/components/colors';
import {formatPrice} from '../../core/services/prices';
import UserStream from '../../users/streams/UserStream';
import UnpaidInvoicesStream from '../streams/UnpaidInvoicesStream';
import {unpaidInvoicesType} from '../types';
import Label from '../../copy/components/Label';

export default (
    use({
            authenticated: AuthStream.as(auth => auth.map(auth => !!auth.id)),
            user: UserStream,
            unpaid: UnpaidInvoicesStream
        },
        ({authenticated, user, unpaid}, {auth: ignore1, user: ignore2, ...props}) => ({
            ...props,
            authenticated,
            balance: get(user, 'data', 'balance') || 0,
            ach: get(user, 'data', 'business', 'ach'),
            net_days: get(user, 'data', 'business', 'net_days'),
            unpaid
        }))(
        createComponent(
            'AccountInfoBalance',
            {
                propTypes: {
                    authenticated: PropTypes.bool.isRequired,
                    balance: PropTypes.number.isRequired,
                    ach: PropTypes.bool,
                    net_days: PropTypes.number,
                    unpaid: (
                        PropTypes.shape({
                            data: PropTypes.shape(unpaidInvoicesType)
                        }))
                }
            },
            ({authenticated, balance, ach, net_days, unpaid}) => (
                (authenticated && unpaid) ?
                    <>
                        {balance < 0 ?
                            <Layout padding={1} color={colors.white_gray}>
                                <Layout padding={{bottom: 1}}>
                                    <Copy setting="small">
                                        You currently have a credit balance of <Type tag="span" weight="bold" color={colors.pink}>${formatPrice(-balance, true)}</Type> on your account.
                                    </Copy>
                                </Layout>
                                <Layout padding={{bottom: 0.25}}>
                                    <Label setting="portal_small">
                                        We'll apply the credit to your next purchase or bill statement, whichever comes first.
                                    </Label>
                                </Layout>
                            </Layout> :
                            null}
                        {(get(unpaid, 'data', 'balance') > 0 && get(unpaid, 'data', 'unresolved') && !get(unpaid, 'data', 'pending')) ?
                            <Layout color={colors.white_gray} padding={1}>
                                <Layout padding={{bottom: 0.25}}>
                                    <Label setting="portal_small" color={colors.red} align="center">
                                        You currently have an outstanding balance of <Type tag="span" weight="bold">${formatPrice(unpaid.data.balance, true)}</Type> on your account. In order to process your payment we need you to&nbsp;
                                        {ach || net_days > 0 ?
                                            <Link
                                                className="text-underline bold text-red"
                                                to={$.url('account:make-payment').url}>

                                                make&nbsp;a&nbsp;payment
                                            </Link> :
                                            <Link
                                                className="text-underline bold text-red"
                                                to={$.url('account:update-payment').url}>

                                                update&nbsp;your&nbsp;credit&nbsp;card
                                            </Link>}.
                                    </Label>
                                </Layout>
                            </Layout> :
                            null}
                        {get(unpaid, 'data', 'pending') ?
                            <Layout color={colors.white_gray} padding={1}>
                                <Layout padding={{bottom: 0.25}}>
                                    <Label setting="portal_small" color={colors.red} align="center">
                                        We're currently processing your payment and it should be reflected on your account <Type tag="span" weight="bold">within the next hour.</Type> We'll send you an email once your payment has processed.
                                    </Label>
                                </Layout>
                            </Layout> :
                            null}
                    </> :
                    null))));
